import React from "react";
import { DatePicker, Button } from "antd";
import dayjs from "dayjs";

const DatePickerComponent = ({ date, setDate }) => {
  const currentDate = dayjs();
  const selectedDate = dayjs(date);
  const isPastDate = selectedDate.isSame(currentDate, "day");

  const disabledDate = (current) => {
    return current && current < currentDate.startOf("day");
  };

  return (
    <div className="reservations-date-picker-container">
      <Button
        onClick={() => setDate((prevDate) => prevDate.subtract(1, "day"))}
        disabled={isPastDate}
      >
        -
      </Button>
      <DatePicker
        allowClear={false}
        value={date}
        format="DD-MM-YYYY"
        onChange={(value) => {
          setDate(value);
        }}
        inputReadOnly={true}
        disabledDate={disabledDate}
      />
      <Button onClick={() => setDate((prevDate) => prevDate.add(1, "day"))}>
        +
      </Button>
    </div>
  );
};

export default DatePickerComponent;
